// import external dependencies
import $ from "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import RL from "./components/retirement-living";
import DS from "./components/disability-services";
import Header from "./components/header";

import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
$(document).ready(() => routes.loadEvents());

window.addEventListener("DOMContentLoaded", function () {
  // Retirement Living
  new RL();

  // Disability Services
  new DS();

  // Header
  new Header();
});



// WEBPACK FOOTER //
// ./scripts/main.js